import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-6 border border-gray-400" }
const _hoisted_2 = { class: "w-full table-auto" }
const _hoisted_3 = { class: "px-3 py-3 border-r border-gray-400" }
const _hoisted_4 = { class: "px-3 py-3 border-r border-gray-400" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", { class: "border-r border-gray-400" }, null, -1)
const _hoisted_6 = { class: "px-3 py-3 border-r border-gray-400" }
const _hoisted_7 = { class: "flex items-center px-3 py-3 border-r border-gray-400" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "w-32 px-3 py-3 border-r border-gray-400" }
const _hoisted_10 = { class: "w-32 px-3 py-3" }

import { PropType } from "vue";

import { DetailedResults } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResultsTable',
  props: {
  index: {
    type: Number,
    required: true,
  },
  result: {
    type: Object as PropType<DetailedResults>,
    required: true,
  },
  response_count: {
    type: Number,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", null, _toDisplayString(`Q${__props.index + 1}.`) + " " + _toDisplayString(__props.result.question_text), 1),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", _hoisted_2, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_3, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.$t("answer-choices")), 1)
            ]),
            _createElementVNode("td", _hoisted_4, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.$t("responses")), 1)
            ]),
            _hoisted_5
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.result.answers, (answer) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: answer.id
            }, [
              _createElementVNode("td", _hoisted_6, _toDisplayString(answer.answer_text), 1),
              _createElementVNode("td", _hoisted_7, [
                _createElementVNode("progress", {
                  max: "100",
                  value: answer.response_percentage,
                  class: "w-full"
                }, null, 8, _hoisted_8)
              ]),
              _createElementVNode("td", _hoisted_9, _toDisplayString(answer.response_percentage) + "%", 1),
              _createElementVNode("td", _hoisted_10, _toDisplayString(answer.response_count), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})